
import {IUserLogEntryBuilder} from './i.user.log.entry.builder';
import {IUserLogEntryOptions} from './i.user.log.entry.options';
import {UserLogEntryHelper}   from './user.log.entry.helper';

/**
 *
 * @class AddTrainBuilder
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      May 2021
 *
 */
export class AddTrainBuilder implements IUserLogEntryBuilder {

  /** convert raw MongoDB user log entry into data that can construct a tree node */
  build(data: any, args: IUserLogEntryOptions): any {

    const u:        string = data._id.match(/^add-train-(.*)/i)[1];

    let name:   string = '';
    let reason: string = data.rsn;
    let sub:    string = (data.sub == '') ? '' : `[${data.sub}]`;
    let before: any    = null;
    let after:  any    = null;

    /* train details */

    const train: any = {
      name:            `${data.tr.n}-${data.tr.d} [ ${data.tr.src.n} - ${data.tr.dst.n} ] ${data.tr.tp}-${data.tr.u}`,
      uuid:            data.tr.u,
      iid:             data.tr.iid,
      kind:            data.tr.tp,
      direction:       data.tr.d,
      source: {
        name:          data.tr.src.n,
        mileage:       data.tr.src.m
      },
      destination: {
        name:          data.tr.dst.n,
        mileage:       data.tr.dst.m
      },
      trainClass:      data.tr.tc,
      tonnage:         data.tr.ton,
      length:          data.tr.l,
      priority:        data.tr.pri,
      overtake:        data.tr.o,
      u:               data.tr._id
    };

    /* track details */

    if (data.tk.a != null) {

      after = {
        name:    data.tk.a.d,
        mileage: data.tk.a.m
      };
    }

    if (data.tk.b != null) {

      before = {
        name:    data.tk.b.d,
        mileage: data.tk.b.m
      };
    }

    const track: any = {
      id:      data.tk.i,
      track:   data.tk.t,
      mileage: data.tk.m,
      before,
      after
    };

    /* format the name */

    name = `<span style="color: dodgerblue;">ADD</span> - <span style="color: white; ; font-weight: bold;">${data.tr.n}-${data.tr.d}</span> (${data.tr.iid}), <span style="color: white; font-weight: bold;">${track.track}</span> (${track.before.name} / ${track.after.name}),  ${sub} ${reason} `;

    /* build it! */

    return {
      id:              data._id,
      seq:             parseInt(data.seq),
      name,
      hasChildren:     args.hasChildren,
      isExpanded:      args.isExpanded,
      type:            'add-train',
      children:        args.children,
      parent:          args.parent,
      kids:            data.ch,
      tags:            data.tg,
      label:           data.lb,
      pkey:            data.pa,
      track,
      train,
      reason,
      sub,
      u
    };

  }
}
